import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Input, InputAdornment, IconButton } from "@mui/material";
import Search from "../../../../assets/icons/search-icon.svg";
import ClearIcon from "@mui/icons-material/Close"; // MUI's clear icon
import PropTypes from "prop-types";

function SearchBar({
  value = "",
  onChange,
  placeholder = "Type here...",
  onKeyDown,
  style = {},
}) {
  const [portalContainer, setPortalContainer] = useState(null);

  useEffect(() => {
    const checkContainer = () => {
      const container = document.getElementById("navbar-search-portal");
      if (container) {
        setPortalContainer(container);
      } else {
        setTimeout(checkContainer, 100);
      }
    };

    checkContainer();
  }, []);

  if (!portalContainer) {
    return null;
  }

  const handleClear = () => {
    // Trigger the onChange event with an empty string
    onChange({ target: { value: "" } });
  };

  const searchElement = (
    <Input
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      placeholder={placeholder}
      startAdornment={
        <InputAdornment position="start">
          <img src={Search} alt="search" style={{ marginRight: "10px" }} />
        </InputAdornment>
      }
      endAdornment={
        value && (
          <InputAdornment position="end">
            <IconButton onClick={handleClear} size="small">
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        )
      }
      disableUnderline
      sx={{
        width: "100%",
        backgroundColor: "white",
        borderRadius: "10px",
        paddingRight: value ? "8px" : 0,
        ...style,
      }}
    />
  );

  return createPortal(searchElement, portalContainer);
}

SearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  onKeyDown: PropTypes.func,
  style: PropTypes.object,
};

export default SearchBar;
